module.exports = __webpack_public_path__ + "img/31_20.a8c1ec4b.png";